import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=5182cf40"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5182cf40')) {
      api.createRecord('5182cf40', component.options)
    } else {
      api.reload('5182cf40', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=5182cf40", function () {
      api.rerender('5182cf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/welfare/edit.vue"
export default component.exports